/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_sip_field_lumpsum = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Total investment`)
};

const es_sip_field_lumpsum = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inversión total`)
};

const de_sip_field_lumpsum = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gesamtinvestition`)
};

const nl_sip_field_lumpsum = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Totale belegging`)
};

const fr_sip_field_lumpsum = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Investissement total`)
};

const it_sip_field_lumpsum = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Investimento totale`)
};

const pt_br2_sip_field_lumpsum = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Investimento total`)
};

const pt_sip_field_lumpsum = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Investimento total`)
};

const ja_sip_field_lumpsum = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`総投資額`)
};

const zh_sip_field_lumpsum = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`总投资金额`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const sip_field_lumpsum = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.sip_field_lumpsum(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("sip_field_lumpsum", locale)
	if (locale === "en") return en_sip_field_lumpsum(inputs)
	if (locale === "es") return es_sip_field_lumpsum(inputs)
	if (locale === "de") return de_sip_field_lumpsum(inputs)
	if (locale === "nl") return nl_sip_field_lumpsum(inputs)
	if (locale === "fr") return fr_sip_field_lumpsum(inputs)
	if (locale === "it") return it_sip_field_lumpsum(inputs)
	if (locale === "pt-BR") return pt_br2_sip_field_lumpsum(inputs)
	if (locale === "pt") return pt_sip_field_lumpsum(inputs)
	if (locale === "ja") return ja_sip_field_lumpsum(inputs)
	return zh_sip_field_lumpsum(inputs)
};